import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

// Mui Components
import {
  Typography,
  TextField,
  Box,
  InputLabel,
  IconButton,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

// Icons
import CloseIcon from '@mui/icons-material/Close';

// Styles
import './styles.scss';

// Yup schema for validation
const campaignSchema = Yup.object().shape({
  campaignName: Yup.string()
    .max(50, 'Campaign Name should be less than or equal to 50 characters')
    .required('Campaign Name is required'),
});

const NameDialog = ({ open, onClose, initialName, onSubmit, isLoading }) => {
  const formId = 'campaign-name-form';

  return (
    <Formik
      initialValues={{
        campaignName: initialName || '',
      }}
      validationSchema={campaignSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <OlcFormModal
          open={open}
          onClose={onClose}
          title="Edit Campaign Name"
          className="campaignNameFormModal"
          footer={
            <>
              <OlcButton variant="secondary" onClick={onClose} type="button">
                Cancel
              </OlcButton>
              <OlcButton
                variant="primary"
                disabled={isLoading || isSubmitting}
                type="submit"
                form={formId}
              >
                {isLoading ? (
                  <CircularProgress
                    sx={{
                      color: '#fff',
                      width: '20px !important',
                      height: '20px !important',
                    }}
                  />
                ) : (
                  'Save'
                )}
              </OlcButton>
            </>
          }
        >
          <Box className="modalFormWrapper campaignNameModalContent">
            <form id={formId} onSubmit={handleSubmit} noValidate>
              <Box className="modalFlexArea">
                <Box className="formFieldWrapper">
                  <InputLabel htmlFor="campaign-name-input" className="inputLabel formLabel">
                    Campaign Name<span className="olcRequired">*</span>
                  </InputLabel>
                  <TextField
                    id="campaign-name-input"
                    placeholder="Campaign Name"
                    fullWidth
                    autoComplete="off"
                    name="campaignName"
                    className="inputField formField"
                    value={values.campaignName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.campaignName && touched.campaignName)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ width: '16px', marginRight: '8px' }}>
                          {values.campaignName && (
                            <IconButton
                              className="cpClearInputBtn"
                              size="small"
                              onClick={() => {
                                setFieldValue('campaignName', '');
                              }}
                              edge="end"
                              sx={{ right: '0px' }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {touched.campaignName && errors.campaignName && (
                    <Typography className="errorMessage">{errors.campaignName}</Typography>
                  )}
                </Box>
              </Box>
            </form>
          </Box>
        </OlcFormModal>
      )}
    </Formik>
  );
};

export default NameDialog;
